import { render } from "./PageProfile.vue?vue&type=template&id=9375d646"
import script from "./PageProfile.vue?vue&type=script&lang=js"
export * from "./PageProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__